(() => {
  'use strict';
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const clamp = value => Math.max(0, Math.min(1, value));
  let tracks = [], frame = null, lastTime = null;
  function refresh() {
    tracks = [];
    document.querySelectorAll('[data-scroll-hero]').forEach(hero => {
      const line = hero.querySelector('[data-hero-line]'), portrait = hero.querySelector('[data-hero-portrait]'), branch = hero.querySelector('[data-hero-branch]');
      if (line && portrait && branch) tracks.push({type:'hero',hero,line,portrait,branch,value:0,target:0,horizontal:0,targetHorizontal:0});
      hero.querySelectorAll('.nf-hero-mobile [class*="HomepageHero_imageWrapper"]').forEach(el => tracks.push({type:'portrait',el,value:0,target:0}));
      const mobile = hero.querySelector('.nf-hero-mobile');
      if (mobile) tracks.push({type:'mobile',el:mobile,dot:mobile.querySelector('[class*="HomepageHero_dot"]'),value:0,target:0});
    });
    document.querySelectorAll('[class*="Growth_sectionWrapper"]').forEach(el => tracks.push({type:'growth',el,value:0,target:0}));
    measure();
  }
  function measure() {
    const height = innerHeight;
    document.querySelector('.header-wrap')?.classList.toggle('nf-header-scrolled', scrollY > 40);
    tracks.forEach(track => {
      if (track.type === 'hero') {
        const area = track.line.parentElement.getBoundingClientRect();
        track.target = motion.matches ? 1 : clamp((height * .58 - area.top) / (area.height * .5));
        track.targetHorizontal = motion.matches ? 1 : clamp((height * .85 - (area.top + area.height * .5)) / (height * .3));
        const tab = track.hero.querySelector('.nf-hero-desktop [data-formula-tabs]');
        // End at the control's actual position instead of a fixed desktop offset.
        const start = track.branch.parentElement.getBoundingClientRect();
        track.branchLength = tab ? Math.min(960, tab.getBoundingClientRect().left + 4 - (start.left + start.width/2)) : start.width;
      } else if (track.type === 'portrait') {
        // Use the layout position: measuring the scaled rectangle causes feedback.
        if (!track.el.offsetParent) { track.target=0; return; }
        const top = track.el.offsetTop + track.el.offsetParent.getBoundingClientRect().top;
        track.target = motion.matches ? 1 : clamp((height * .9 - top) / (height * .35));
      } else if (track.type === 'mobile') {
        const rect = track.el.getBoundingClientRect();
        track.distance = Math.max(0, rect.height - 32);
        track.target = motion.matches ? 1 : clamp((height * .55 - rect.top) / Math.max(1, track.distance));
      } else {
        const rect = track.el.getBoundingClientRect();
        track.target = motion.matches ? 1 : clamp((height * .75 - rect.top) / Math.max(height * .5, rect.height * .65));
      }
    });
    if (frame === null) { lastTime = null; frame = requestAnimationFrame(draw); }
  }
  function draw(time) {
    frame = null;
    const amount = motion.matches ? 1 : 1-Math.exp(-Math.min(lastTime === null ? 16 : time-lastTime,64)/90);
    lastTime = time;
    let moving = false;
    tracks.forEach(track => {
      track.value += (track.target - track.value) * amount;
      if (Math.abs(track.value-track.target) < .001) track.value=track.target;
      moving ||= track.value !== track.target;
      if (track.type === 'hero') {
        track.horizontal += (track.targetHorizontal-track.horizontal) * amount;
        if (Math.abs(track.horizontal-track.targetHorizontal) < .001) track.horizontal=track.targetHorizontal;
        moving ||= track.horizontal !== track.targetHorizontal;
        track.line.style.height = `${track.value * 50}%`;
        track.line.classList.toggle('HomepageHero_playing__geTMK',track.value < 1);
        const reveal = motion.matches ? 1 : clamp((track.value-.7)/.3);
        track.portrait.style.transform = `scale(${reveal})`;
        track.portrait.style.opacity = String(reveal);
        track.branch.style.width = `${Math.max(0,track.branchLength) * track.horizontal}px`;
        track.branch.classList.toggle('HomepageHero_finished__Zowgz',track.horizontal >= .999);
        track.hero.dataset.scrollProgress = track.value.toFixed(3);
      } else if (track.type === 'portrait') {
        track.el.style.transform = `scale(${track.value})`;
        track.el.style.opacity = String(track.value);
      } else if (track.type === 'mobile') {
        if (track.dot) track.dot.style.transform = `translateY(${track.value * track.distance}px)`;
      } else {
        track.el.style.setProperty('--growth-progress',track.value);
        track.el.querySelectorAll('.copy-wrapper-ref').forEach((copy,index) => {
          const active = track.value >= index/3;
          copy.style.opacity = active ? '1' : '.6';
          copy.closest('.w-full')?.querySelector('.tag')?.classList.toggle('nf-growth-active',active);
        });
      }
    });
    if (moving) frame=requestAnimationFrame(draw);
  }
  addEventListener('scroll',measure,{passive:true});
  addEventListener('resize',measure,{passive:true});
  addEventListener('load',measure);
  document.addEventListener('shopify:section:load',refresh);
  motion.addEventListener('change',measure);
  refresh();
})();
